<template>
  <div class="invest">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('menu.purchasingInterestRate') }}
        </h3>
        <div class="box-tools pull-right">
          <template v-if="can([$Permissions.backend.interestRate.purchasing.store])">
            <router-link
              :to="{name: 'create-purchasing-interest-rate'}"
              class="btn btn-primary btn-sm"
              data-widget="remove"
            >
              <i class="fa fa-plus-circle" /> {{ $t('button.add') }}
            </router-link>
          </template>
        </div>
      </div>
      <div class="box-body">
        <table
          id="personal-loan-interest-rate-table"
          class="table table-hover table-striped table-bordered"
        >
          <thead>
            <tr>
              <th>{{ $t('table.action') }}</th>
              <th>{{ $t('table.createdAt') }}</th>
              <th>{{ $t('table.startAmount') }}</th>
              <th>{{ $t('table.endAmount') }}</th>
              <th>{{ $t('table.startMonth') }}</th>
              <th>{{ $t('table.endMonth') }}</th>
              <th>{{ $t('table.percentage') }}</th>
            </tr>
          </thead>
          <tbody />
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'List',
  metaInfo () {
    return {
      title: this.$t('menu.purchasingInterestRate'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      oTable: null
    }
  },
  watch: {
    '$i18n.locale': function () {
      this.oTable.clear()
      this.oTable.destroy()
      this.oTable = this.refreshTable()
      this.oTable.draw(true)
    },
    oTable: function () {
      this.setButtonAction()
    }
  },
  computed: {
    columns () {
      return [
        {
          data: 'action',
          name: 'action',
          searchable: false,
          orderable: false,
          width: '2%',
          title: this.$t('table.action')
        },
        {
          data: 'created_at',
          name: 'created_at',
          searchable: false,
          width: '8%',
          title: this.$t('table.createdAt')
        },
        { data: 'start_amount', name: 'start_amount', width: '8%', title: this.$t('table.startAmount') },
        { data: 'end_amount', name: 'end_amount', width: '8%', title: this.$t('table.endAmount') },
        { data: 'start', name: 'start', width: '8%', title: this.$t('table.startMonth') },
        { data: 'end', name: 'end', width: '8%', title: this.$t('table.endMonth') },
        { data: 'percentage', name: 'percentage', width: '8%', title: this.$t('table.percentage') }
      ]
    }
  },
  methods: {
    deleteInterest (id) {
      const self = this
      this.$swal({
        title: self.$t('string.areYouSure?'),
        text: self.$t('string.youWillNotBeAbleToRevertThis!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: self.$t('string.yesDeleteIt'),
        cancelButtonText: self.$t('button.cancel')
      }).then((result) => {
        if (result.value) {
          self.$axios.post(process.env.VUE_APP_API + '/api/v1/interest-rate/purchasing/delete', { id: id })
            .then((response) => {
              self.oTable.draw(true)
              self.$swal({
                title: self.$t('string.deleteInterestRateRequest!'),
                text: self.$t('string.theRecordHasBeenDeleted!'),
                type: response.data.code === 200 ? 'success' : 'error',
                confirmButtonText: self.$t('button.ok')
              })
            })
        }
      })
        .catch((error) => {
          this.onResponseError(error)
        })
    },
    refreshTable () {
      const self = this
      return $('#personal-loan-interest-rate-table').DataTable({
        stateSave: true,
        processing: true,
        serverSide: true,
        scrollX: true,
        scrollCollapse: true,
        lengthMenu: this.$lengthMenu,
        ajax: {
          method: 'POST',
          url: process.env.VUE_APP_API + '/api/v1/interest-rate/purchasing',
          data: (d) => {
            d.labelEdit = self.$t('label.edit')
            d.labelDelete = self.$t('label.delete')
            d.noPermission = self.$t('string.noPermission')
          },
          error: (xhr) => {
            this.onAccessDenied(xhr)
          }
        },
        columns: self.columns,
        order: [[2, 'asc']],
        language: {
          url: `/locale/${this.$i18n.locale}.json`
        }
      })
    },
    setButtonAction () {
      this.clearEventHandlers([
        '.interest-rate-delete',
        '.interest-rate-edit'
      ])
      const self = this
      $(document).on('click', '.interest-rate-delete', function () {
        self.deleteInterest($(this).attr('data-interest-rate'))
      })

      $(document).on('click', '.interest-rate-edit', function () {
        const id = $(this).attr('data-interest-rate')
        self.$router.push({
          name: 'edit-purchasing-interest-rate',
          params: {
            id: id
          }
        })
      })
    }
  },
  mounted () {
    const self = this
    this.$nextTick(() => {
      $(function () {
        self.oTable = self.refreshTable()
      })
    })
  },
  beforeDestroy () {
    this.oTable.clear()
    this.oTable.destroy()
  }
}
</script>

<style scoped>

</style>
